/**
 * @module lineheight/lineheight
 */

import { Plugin } from 'ckeditor5/src/core';

import ParagraphSpacingEditing from './paragraphspacing/paragraphspacingediting';
import ParagraphSpacingUI from './paragraphspacing/paragraphspacingui';

/**
 * The line height plugin.
 *
 * @extends Plugin
 */
export default class ParagraphSpacing extends Plugin {
	/**
	 * @inheritDoc
	 */
	static get requires() {
		return [ ParagraphSpacingEditing, ParagraphSpacingUI ];
	}

	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'ParagraphSpacing';
	}
}
